<template>
	<div>
		<div>
			<el-carousel trigger="click" height="500px">
			  <el-carousel-item v-for="(item, index) in images" :key="index">
			    <el-image
			      style="width: 100%; height: 500px"
			      :src="item"
			      fit="fill"
			    ></el-image>
			  </el-carousel-item>
			</el-carousel>
		</div>
		<div style="width: 70%;margin: auto;">
			<p style="width: 325px;margin: 5px auto;border-bottom: 5px solid red;line-height: 30px;">会讯|首届全国湿疹皮炎皮肤过敏学术会议回顾</p>
			<p style="font-size: 14px;text-indent: 2em;">2019年6月29日，由中国中西医结合学会皮肤性病专业委员会主办的“首届国湿疹皮炎皮肤过敏学术会议”在上海圆满闭幕。</p>
			<p>
				<el-image
				  style="width: 100%;"
				  src="http://www.fulqun.com/uploadfile/2019/0902/20190902064301164.jpg"
				  fit="fill"
				></el-image>
			</p>
			<p style="font-size: 14px;text-indent: 2em;">中国医学科学院皮肤病研究所的孙建芳教授、意大利罗马大学的Andy Goren教授、日本大阪大学的片山一朗教授、北京大学第一医院的涂平教授、昆明医科大学第一附属医院的何黎教授、北京友谊医院的李邻峰教授、复旦大学附属华山医院的徐金华教授等专家进行了精彩演讲，分享了他们在湿疹皮炎基础与临床方面的最新进展。</p>
			<p>
				<el-image
				  style="width: 100%;"
				  src="http://www.fulqun.com/uploadfile/2019/0902/20190902064343302.jpg"
				  fit="fill"
				></el-image>
			</p>
			<p style="font-size: 14px;text-indent: 2em;">李邻峰教授也就皮肤表皮渗透的持久性问题、皮肤屏障的修复等问题做了分享，并以芙汭皮肤屏障立体修复霜为例对PatcH2O、酵母菌发酵溶胞产物滤液（Frapertide）、神经酰胺黄芩苷脂质体复合物、原花青素（OPC）等成分的临床实验结果进行了深入分析和系统讲解。（了解更多成分详情，点击蓝字可查看往期推文。）</p>
			<p>
				<el-image
				  style="width: 100%;"
				  src="http://www.fulqun.com/uploadfile/2019/0902/20190902064407190.jpg"
				  fit="fill"
				></el-image>
			</p>
			<p style="font-size: 14px;text-indent: 2em;">
				会议还设置了湿疹皮炎、瘙痒诊治论坛、荨麻疹药疹接触性皮炎论坛、过敏针织及过敏原监测论坛、治疗技术及新疗法论坛等分会场。湿疹皮炎皮肤过敏类皮肤病，包括接触性皮炎、特应性皮炎、神经性皮炎、感染性皮炎、痒疹、药物性皮炎、荨麻疹、皮肤血管炎等多种皮肤疾病。
			</p>
			<p style="font-size: 14px;text-indent: 2em;">
				第一届全国湿疹皮炎皮肤过敏学术会议过去了，第二届还会远吗？期待下次再聚。
			</p>
		</div>
		<div class="footer">
			<ul class="putbox">
				<li>© 北京安德普泰医疗科技有限公司 2021 All Rights Reserved.</li>
				<li>邮箱：demon211@sohu.com</li>
				<li>
					地址：北京市大兴区中关村科技园区大兴生物医药产业基地天华大街5号院13号楼11层1104室、1105
				</li>
				<li>
					<a href="https://beian.miit.gov.cn/">京ICP备18032874号-7</a>
				</li>
				<li>
					<a @click="go">互联网产品信息服务资格证书：（京）-非经营性-xxxx-xxxx号</a>
				</li>
			</ul>
			<div class="contactbox">
				<p>010-50846938</p>
				<p>周一至周五 9:00-17:30</p>
				<p>在线客服</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				images: [
				  "https://uplabimg.andupchain.com/%E5%AE%98%E7%BD%91/2d6dd2e5-2093-481b-82df-cd52161e40e5.png",
				],
			}
		},
		methods:{
			go() {
				this.$router.push('/certification')
			}
		}
	}
</script>

<style scoped>
	.footer {
		height: 200px;
		padding: 30px;
		background-color: rgb(250, 250, 250);
		display: flex;
		justify-content: space-between;
	}
	
	.putbox {
		list-style: none;
		font-size: 12px;
		width: 70%;
		margin-top: 10px;
		padding-left: 10%;
		line-height: 30px;
	}
	
	.putbox a {
		text-decoration: none;
		color: #666;
	}
	
	.contactbox {
		width: 30%;
		height: 100%;
		text-align: center;
		line-height: 50px;
	}
	
	.contactbox p:nth-child(1) {
		color: rgb(65, 110, 179);
		font-size: 28px;
	}
	
	.contactbox p:nth-child(2) {
		font-size: 14px;
		color: #666;
	}
	
	.contactbox p:nth-child(3) {
		width: 180px;
		height: 36px;
		margin: auto;
		border: 1px solid rgb(65, 110, 179);
		color: rgb(65, 110, 179);
		line-height: 36px;
		cursor: pointer;
	}
</style>
